module.exports = __webpack_public_path__ + "img/Antman_01.d40cddbc.png";